export const gqstep2 = [
  {
    label: "基金名称",
    field: "fundName",
    formtype: "",
    require: false
  },

  {
    label: "基金是否在中基协备案",
    field: "associtionRegisted",
    formtype: "select",
    options: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 0
      }
    ],
    require: false
  },

  {
    label: "基金备案日期",
    field: "associtionRegistedTime",
    formtype: "date",
    require: false
  },
  {
    label: "基金成立日期",
    field: "registeTime",
    formtype: "date",
    require: false
  },
  {
    label: "基金到期日期",
    field: "expireTime",
    formtype: "date",
    require: false
  },
  {
    label: "存续期限（月）",
    field: "keepMouth",
    formtype: "",
    require: false
  },
  {
    label: "基金类型",
    field: "fundType",
    formtype: "select",
    options: [
      {
        label: "私募股权投资基金",
        value: "私募股权投资基金"
      },
      {
        label: "创业投资基金",
        value: "创业投资基金"
      },
      {
        label: "私募证券投资基金",
        value: "私募证券投资基金"
      },
      {
        label: "持股平台",
        value: "持股平台"
      },
      {
        label: "自有资金投资类企业",
        value: "自有资金投资类企业"
      }
    ],
    require: false
  },
  {
    label: "认缴规模(万元)",
    field: "capitalAdmit",
    formtype: "",
    require: false
  },
  {
    label: "实缴规模(万元)",
    field: "capitalPaid",
    formtype: "",
    require: false
  },
  {
    label: "托管机构名称",
    field: "entrustInstitutionName",
    formtype: "",
    require: false
  }
];

export const subzqstep2 = [
  {
    label: "子基金名称",
    field: "fundName",
    formtype: "",
    require: false
  },
  {
    label: "子基金是否在中基协备案",
    field: "associtionRegisted",
    formtype: "select",
    options: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 0
      }
    ],
    require: false
  },
  {
    label: "子基金注册地",
    field: "registedAddress",
    formtype: "",
    require: false
  },

  {
    label: "子基金管理人名称",
    field: "mgrInstitutionName",
    formtype: "",
    require: false
  },
  {
    label: "FOF子基金管理人是否在中基协登记",
    field: "mgrRegisted",
    formtype: "select",
    options: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 0
      }
    ],
    require: false
  },
  {
    label: "FOF子基金管理人注册地",
    field: "mgrAddress",
    formtype: "",
    require: false
  }
];

export const subgqstep2 = [
  {
    label: "子基金名称",
    field: "fundName",
    formtype: "",
    require: false
  },
  {
    label: "子基金是否在中基协备案",
    field: "associtionRegisted",
    formtype: "select",
    options: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 0
      }
    ],
    require: false
  },
  {
    label: "基金备案日期",
    field: "associtionRegistedTime",
    formtype: "date",
    require: false
  },
  {
    label: "实缴规模(万元)",
    field: "capitalPaid",
    formtype: "",
    require: false
  },
  {
    label: "投资时间",
    field: "investTime",
    formtype: "date",
    require: false
  },
  {
    label: "子基金注册地",
    field: "registedAddress",
    formtype: "",
    require: false
  }
];

export const gqstep3 = [
  {
    label: "被投资公司全称",
    field: "bottomCompanyName",
    formtype: "",
    require: false
  },
  {
    label: "被投资公司成立时间",
    field: "bottomCompanyRegistedTime",
    formtype: "date",
    require: false
  },
  {
    label: "被投资公司注册地--投资省份",
    field: "investProvince",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "被投资公司注册地--投资城市",
    field: "investCity",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "被投资公司注册地--投资地区",
    field: "investDistrict",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "投资金额（万元）",
    field: "capitalInvested",
    formtype: "",
    require: false,
    rules: []
  },
  {
    label: "投资时间",
    field: "investTime",
    formtype: "date",
    require: false
  },
  {
    label: "持股比例（如50%请填写0.5）",
    field: "cgRatio",
    formtype: "",
    require: false
  },
  {
    label: "所属类型",
    field: "type",
    formtype: "",
    require: false
  },
  {
    label: "所处阶段",
    field: "stage",
    formtype: "",
    require: false
  },
  {
    label: "政府认定类型",
    field: "governmentAdmitType",
    formtype: "",
    require: false
  },
  {
    label: "所属行业",
    field: "industry",
    formtype: "",
    require: false
  },
  {
    label: "投资形式",
    field: "investType",
    formtype: "",
    require: false
  },
  {
    label: "目前投资账面价值",
    field: "investValue",
    formtype: "",
    require: false
  },
  {
    label: "退出现状",
    field: "quitStatus",
    formtype: "",
    require: false
  },
  {
    label: "退出时间",
    field: "quitTime",
    formtype: "date",
    require: false
  },
  {
    label: "退出方式",
    field: "quitType",
    formtype: "",
    require: false
  },
  {
    label: "退出金额（万元）",
    field: "quitCapital",
    formtype: "",
    require: false
  },
  {
    label: "盈利倍数（推出金额/投资本金）",
    field: "profitMultiple",
    formtype: "",
    require: false
  },
  {
    label: "是否为管理人自身或关联方项目",
    field: "mgrSelf",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "1"
      },
      {
        label: "否",
        value: "0"
      }
    ],
    require: false
  },
  {
    label: "是否最终投向P2P、民间借贷等",
    field: "p2p",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "1"
      },
      {
        label: "否",
        value: "0"
      }
    ],
    require: false
  },
  {
    label: "投资项目风险状况",
    field: "investRiskInfo",
    formtype: "",
    require: false
  },
  {
    label: "联系人",
    field: "investedLinkMan",
    formtype: "",
    require: false
  },
  {
    label: "所在部门",
    field: "investedDepartment",
    formtype: "",
    require: false
  },
  {
    label: "职务",
    field: "investedPosition",
    formtype: "",
    require: false
  },
  {
    label: "办公电话",
    field: "officeTel",
    formtype: "",
    require: false
  },
  {
    label: "手机号码",
    field: "mobile",
    formtype: "",
    require: false
  },
  {
    label: "需要说明的事项",
    field: "extraInfo",
    formtype: "",
    require: false
  }
];

export const zqstep3 = [
  {
    label: "上市公司名称",
    field: "sscompanyNam",
    formtype: "",
    require: false
  },
  {
    label: "上市公司注册地",
    field: "sscompanyAddress",
    formtype: "",
    require: false
  },
  {
    label: "参与定增时间",
    field: "dzTime",
    formtype: "date",
    require: false
  },
  {
    label: "定增基金/持股比例（如：50% 请输入0.5）",
    field: "dzRatio",
    formtype: "",
    require: false
  },
  {
    label: "参与定增金额（万元）",
    field: "dzCapital",
    formtype: "",
    require: false
  },
  {
    label: "目前定增持股市值（万元）",
    field: "dzCurrentCgsz",
    formtype: "",
    require: false
  },
  {
    label: "AA及以上持仓占比（如：50% 请输入0.5）",
    field: "aaRatio",
    formtype: "",
    require: false
  },
  {
    label: "A到BBB持仓占比（如：50% 请输入0.5）",
    field: "abbbRatio",
    formtype: "",
    require: false
  },
  {
    label: "BB及以下持仓占比（如：50% 请输入0.5）",
    field: "bbRatio",
    formtype: "",
    require: false
  },
  {
    label: "利率债持仓占比（如：50% 请输入0.5）",
    field: "holdcRatio",
    formtype: "",
    require: false
  },
  {
    label: "加权久期",
    field: "jqjq",
    formtype: "",
    require: false
  },
  {
    label: "是否为管理人自身或关联方公司",
    field: "mgrSelf",
    formtype: "select",
    options: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 0
      }
    ],
    require: false
  },
  {
    label: "是否最终投向p2p、民间借贷等",
    field: "p2p",
    formtype: "select",
    options: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 0
      }
    ],
    require: false
  },
  {
    label: "投资标的风险状况",
    field: "investRiskInfo",
    formtype: "",
    require: false
  },
  {
    label: "需要说明的事项",
    field: "extraInfo",
    formtype: "",
    require: false
  }
];

export const zqstep2 = [
  {
    label: "管理人名称",
    field: "mgrInstitutionName",
    formtype: "",
    require: false
  },
  {
    label: "存续基金名称",
    field: "fundName",
    formtype: "",
    require: false
  },

  {
    label: "基金是否在中基协备案",
    field: "associtionRegisted",
    formtype: "select",
    options: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 0
      }
    ],
    require: false
  },

  {
    label: "基金注册地",
    field: "registedAddress",
    formtype: "",
    require: false
  },
  {
    label: "基金成立日期",
    field: "registeTime",
    formtype: "date",
    require: false
  },
  {
    label: "存续期限（月）",
    field: "keepMouth",
    formtype: "",
    require: false
  },
  {
    label: "基金类型",
    field: "fundType",
    formtype: "select",
    options: [
      {
        label: "私募股权投资基金",
        value: "私募股权投资基金"
      },
      {
        label: "创业投资基金",
        value: "创业投资基金"
      },
      {
        label: "私募证券投资基金",
        value: "私募证券投资基金"
      },
      {
        label: "持股平台",
        value: "持股平台"
      },
      {
        label: "自有资金投资类企业",
        value: "自有资金投资类企业"
      }
    ],
    require: false
  },
  {
    label: "投资策略",
    field: "investIdea",
    formtype: "",
    require: false
  },

  {
    label: "存续规模（万元）",
    field: "capitalPaid",
    formtype: "",
    require: false
  },

  {
    label: "募集机构名称",
    field: "raiseInstitutionName",
    formtype: "",
    require: false
  },
  {
    label: "托管机构名称",
    field: "entrustInstitutionName",
    formtype: "",
    require: false
  },
  {
    label: "向投资者披露基金信息频率",
    field: "publicInformation",
    formtype: "",
    require: false
  },
  {
    label: "上季度末净值",
    field: "lastQuarterRealValue",
    formtype: "",
    require: false
  },
  {
    label: "本季度末净值",
    field: "currentQuarterRealValue",
    formtype: "",
    require: false
  },
  {
    label: "本季度末比上季度末增长（本季度末净值-上季度净值 单位万元）",
    field: "realValueDifference",
    formtype: "",
    require: false
  },
  {
    label: "本季末仓位水平",
    field: "currentQuarterWareLevel",
    formtype: "",
    require: false
  },
  {
    label: "重仓行业",
    field: "commonIndustry",
    formtype: "",
    require: false
  }
];

export const step2 = [
  {
    label: "基金名称",
    field: "fundName",
    formtype: "",
    require: false
  },
  {
    label: "基金类型",
    field: "fundType",
    formtype: "select",
    options: [
      {
        label: "私募股权投资基金",
        value: "私募股权投资基金"
      },
      {
        label: "创业投资基金",
        value: "创业投资基金"
      },
      {
        label: "私募证券投资基金",
        value: "私募证券投资基金"
      },
      {
        label: "持股平台",
        value: "持股平台"
      },
      {
        label: "自有资金投资类企业",
        value: "自有资金投资类企业"
      }
    ],
    require: false
  },
  {
    label: "工商登记时间",
    field: "gsRegistedTime",
    formtype: "date",
    require: false
  },
  {
    label: "认缴资本(万元)",
    field: "admittedCapital",
    formtype: "",
    require: false
  },
  {
    label: "实缴到位资本(万元)",
    field: "paidCapital",
    formtype: "",
    require: false
  },
  {
    label: "已投资金额(万元)",
    field: "capitalInvested",
    formtype: "",
    require: false
  },
  {
    label: "注册省份",
    field: "registeProvince",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "注册市州",
    field: "registeCity",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "注册区域",
    field: "registeDistrict",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "主要投资领域",
    field: "fundIndustry",
    formtype: "select",
    options: [],
    require: false
  }
];

export const step2Agency = [
  {
    label: "投资项目",
    field: "bottomCompanyName",
    formtype: "",
    require: false
  },
  {
    label: "投资省份",
    field: "investProvince",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "投资市州(限省内)",
    field: "investCity",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "投资县市区(限省内)",
    field: "investDistrict",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "是否属于科技创新或先进制造类企业",
    field: "iskjcxorxjzz",
    formtype: "select",
    options: [
      {
        label: "科技创新",
        value: "科技创新"
      },
      {
        label: "先进制造",
        value: "先进制造"
      }
    ],
    require: false
  },
  {
    label: "是否为民营企业",
    field: "ismyqy",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "是"
      },
      {
        label: "否",
        value: "否"
      }
    ],
    require: false
  },
  {
    label: "是否为上市后备企业",
    field: "issshbqy",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "是"
      },
      {
        label: "否",
        value: "否"
      }
    ],
    require: false
  },
  {
    label: "是否为“专精特新”小巨人企业",
    field: "iszjtx",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "是"
      },
      {
        label: "否",
        value: "否"
      }
    ],
    require: false
  },
  {
    label: "是否为上市企业",
    field: "isssqy",
    formtype: "select",
    options: [
      {
        label: "是",
        value: "是"
      },
      {
        label: "否",
        value: "否"
      }
    ],
    require: false
  },

  {
    label: "投资金额（万元）",
    field: "capitalInvested",
    formtype: "",
    require: false
  },
  {
    label: "投资时间",
    field: "investTime",
    formtype: "date",
    require: false
  },
  {
    label: "投资阶段",
    field: "stage",
    formtype: "select",
    options: [
      {
        label: "种子期",
        value: "种子期"
      },
      {
        label: "天使期",
        value: "天使期"
      },
      {
        label: "初创期",
        value: "初创期"
      },
      {
        label: "成长期",
        value: "成长期"
      },
      {
        label: "成熟期",
        value: "成熟期"
      }
    ],
    require: false
  },
  {
    label: "投资行业",
    field: "industry",
    formtype: "select",
    options: [],
    require: false
  }
];

export const step3Agency = [
  {
    label: "投资项目",
    field: "bottomCompanyName",
    formtype: "",
    require: false
  },
  {
    label: "投资省份",
    field: "investProvince",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "投资城市",
    field: "investCity",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "投资地区",
    field: "investDistrict",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "投资金额（万元）",
    field: "capitalInvested",
    formtype: "",
    require: false
  },
  {
    label: "投资时间",
    field: "investTime",
    formtype: "date",
    require: false
  },
  {
    label: "投资阶段",
    field: "stage",
    formtype: "select",
    options: [
      {
        label: "初创期",
        value: "初创期"
      },
      {
        label: "成长期",
        value: "成长期"
      },
      {
        label: "成熟期",
        value: "成熟期"
      }
    ],
    require: false
  },
  {
    label: "投资行业",
    field: "industry",
    formtype: "select",
    options: [],
    require: false
  }
];
//step3

export const step3 = [
  {
    label: "拟认缴资本（万元）",
    field: "admittedCapital",
    formtype: "",
    require: false
  },
  {
    label: "注册省份",
    field: "registeProvince",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "注册市州",
    field: "registeCity",
    formtype: "select",
    options: [],
    require: false
  },

  {
    label: "拟投领域",
    field: "fundIndustry",
    formtype: "select",
    options: [],
    require: false
  }
];

//step4
export const step4 = [
  {
    label: "变更事项",
    field: "changeItem",
    formtype: "",
    require: false
  },
  {
    label: "变更时间",
    field: "changeTime",
    formtype: "date",
    require: false
  },
  {
    label: "原登记内容",
    field: "changeOldContent",
    // inputType: 'textarea',
    inputType: "textarea",

    formtype: "",
    require: false
  },
  {
    label: "变更后登记内容",
    field: "changeNewContent",
    inputType: "textarea",
    formtype: "",
    require: false
  },
  {
    label: "变更事项说明",
    field: "changeExplain",
    inputType: "textarea",
    width: "100%",
    formtype: "",
    require: false
  }
];

export const step5 = [
  {
    label: "底层资产名称",
    field: "bottomCapitalName",
    formtype: "",
    require: false
  },
  {
    label: "所属行业",
    field: "fundIndustry",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "投资金额(万元)",
    field: "capitalInvested",
    formtype: "",
    require: false
  },
  {
    label: "投资地区",
    field: "investProvince",
    formtype: "select",
    options: [],
    require: false
  },
  {
    label: "投资时间",
    field: "investTime",
    formtype: "date",
    require: false
  },
  {
    label: "退出时间",
    field: "investOutTime",
    formtype: "date",
    options: [],
    require: false
  },
  {
    label: "投向公司自身或关联方项目情况",
    field: "investedRelatedInfo",
    formtype: "",
    require: false
  },
  {
    label: "是否最终投向P2P、民间借贷等",
    field: "p2p",
    formtype: "select",
    options: [
      {
        label: "是",
        value: true
      },
      {
        label: "否",
        value: false
      }
    ],
    require: false
  },
  {
    label: "投资项目风险状况",
    field: "investRiskInfo",
    formtype: "",
    require: false
  },
  {
    label: "基金净值（证券类基金适用）（万元）",
    field: "fundRealValue",
    formtype: "",
    require: false
  },
  {
    label: "其他需要说明的事项",
    field: "extraInfo",
    formtype: "",
    require: false
  }
];

export const step21 = [
  {
    label: "基金名称",
    field: "fundName",
    formtype: "",
    require: false
  },
  {
    label: "基金类型",
    field: "fundType",
    formtype: "select",
    options: [
      {
        label: "私募股权投资基金",
        value: "私募股权投资基金"
      },
      {
        label: "创业投资基金",
        value: "创业投资基金"
      },
      {
        label: "私募证券投资基金",
        value: "私募证券投资基金"
      },
      {
        label: "持股平台",
        value: "持股平台"
      },
      {
        label: "自有资金投资类企业",
        value: "自有资金投资类企业"
      }
    ],
    require: false
  },
  {
    label: "认缴规模(万元)",
    field: "capitalAdmit",
    formtype: "",
    require: false
  },
  {
    label: "实缴规模(万元)",
    field: "capitalPaid",
    formtype: "",
    require: false
  },
  {
    label: "投资者人数(人)",
    field: "investorCount",
    formtype: "",
    require: false
  },
  {
    label: "托管机构名称",
    field: "mgrInstitution",
    formtype: "",
    require: false
  }
];

export const gqstep21 = [
  {
    label: "基金名称",
    field: "fundName",
    formtype: "",
    require: false
  },

  {
    label: "基金是否在中基协备案",
    field: "associtionRegisted",
    formtype: "select",
    options: [
      {
        label: "是",
        value: 1
      },
      {
        label: "否",
        value: 0
      }
    ],
    require: false
  },

  {
    label: "基金备案日期",
    field: "associtionRegistedTime",
    formtype: "date",
    require: false
  },
  {
    label: "基金成立日期",
    field: "registeTime",
    formtype: "date",
    require: false
  },
  {
    label: "基金到期日期",
    field: "expireTime",
    formtype: "date",
    require: false
  },
  {
    label: "存续期限（月）",
    field: "keepMouth",
    formtype: "",
    require: false
  },
  {
    label: "基金类型",
    field: "fundType",
    formtype: "select",
    options: [
      {
        label: "私募股权投资基金",
        value: "私募股权投资基金"
      },
      {
        label: "创业投资基金",
        value: "创业投资基金"
      },
      {
        label: "私募证券投资基金",
        value: "私募证券投资基金"
      },
      {
        label: "持股平台",
        value: "持股平台"
      },
      {
        label: "自有资金投资类企业",
        value: "自有资金投资类企业"
      }
    ],
    require: false
  },
  {
    label: "认缴规模(万元)",
    field: "capitalAdmit",
    formtype: "",
    require: false
  },
  {
    label: "实缴规模(万元)",
    field: "capitalPaid",
    formtype: "",
    require: false
  },
  {
    label: "托管机构名称",
    field: "entrustInstitutionName",
    formtype: "",
    require: false
  }
];
